import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TypedActivatedRoute } from '@assetaccountant/core/utils/route-utils';
import { IntegrationType } from '@assetaccountant/integrations/models/integration-type';
import { IntegrationsService } from '@assetaccountant/integrations/services/integrations.service';

import { AuthenticationService } from '../../../core/services/authentication.service';
import { QuickBooksService } from '../../services/quickbooks.service';

@Component({
  selector: 'app-quickbooks-launch-realm',
  templateUrl: './quickbooks-launch-realm.component.html',
  styleUrls: ['./quickbooks-launch-realm.component.scss'],
  standalone: false,
})
export class QuickBooksLaunchRealmComponent implements OnInit {
  constructor(
    @Inject(ActivatedRoute)
    private route: TypedActivatedRoute<{}, {}, { realmId: string; isRelog?: boolean }>,
    private authService: AuthenticationService,
    private quickBooksService: QuickBooksService,
    private router: Router,
    private integrationService: IntegrationsService,
  ) {}

  get title() {
    return { pageTitle: `QuickBooks App Launcher` };
  }

  async ngOnInit() {
    const returnUrl = new URL(location.href);

    if (!returnUrl.searchParams.has('isRelog')) {
      returnUrl.searchParams.append('isRelog', 'true');
    }

    // If the user is not authenticated, we need to authenticate them with the external identity provider.
    if (!this.authService.isAuthenticated()) {
      this.authService.init(returnUrl.toString(), { acr_values: 'idp:Intuit' });
      return;
    }

    // Ensure the user is authenticated with the correct identity provider.
    if (!this.route.snapshot.queryParams.isRelog) {
      this.authService.logOut(returnUrl.toString());
      return;
    }

    if (this.route.snapshot.queryParams.realmId) {
      this.integrationService
        .listIntegrations(IntegrationType.QuickBooks, this.route.snapshot.queryParams.realmId)
        .subscribe(listConnectionsResponse => {
          const connections = listConnectionsResponse.integrations;

          if (connections.length === 0) {
            this.quickBooksService.initiateOAuth(location.href);
          } else if (connections.length === 1) {
            this.router.navigate([`/organisations/-/registers/${connections[0].registerId}`]);
          } else {
            this.router.navigate(['/organisations/-']);
          }
        });
    } else {
      this.quickBooksService.initiateOAuth(location.href);
    }
  }
}
